import React from 'react'

import { Flex } from 'lese'
import { ArrowLeft } from 'react-feather'

import Header from 'Components/shared/Header'
import ReportCSV from 'Components/shared/ReportCsv'
import { ClickableLink } from 'Components/shared/Link'

import { SORTINGTYPES } from 'Constants'
import { setEncounterViewType } from 'Store/encounters'

const tcodeSortParams = {
  type: SORTINGTYPES.TCODES,
  reverse: true
}

export default ({ title, tCodes, medicalRef }) => {
  const tcodeSearchParams = {
    searchParam: {
      keys: ['T-Code'],
      values: [tCodes.map(item => item.t_code)]
    }
  }

  const tcodeHeadingParams = {
    type: 'Patient Ref',
    data: medicalRef
  }

  return (
    <Header>
      <ClickableLink yAlign onClick={setEncounterViewType}>
        <ArrowLeft />
        BACK
      </ClickableLink>
      {title}
      <Flex separation="12px" yAlign>
        <ReportCSV
          sortingParams={tcodeSortParams}
          searchParams={tcodeSearchParams}
          headingParams={tcodeHeadingParams}
        />
      </Flex>
    </Header>
  )
}
